var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.4 22.75h-3.8c-4.39 0-6.35-1.96-6.35-6.35v-3.8c0-4.39 1.96-6.35 6.35-6.35h3c.41 0 .75.34.75.75s-.34.75-.75.75h-3c-3.58 0-4.85 1.27-4.85 4.85v3.8c0 3.58 1.27 4.85 4.85 4.85h3.8c3.58 0 4.85-1.27 4.85-4.85v-3c0-.41.34-.75.75-.75s.75.34.75.75v3c0 4.39-1.96 6.35-6.35 6.35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.9996 14.15h-3.2c-2.81 0-3.94999-1.14-3.94999-3.95v-3.20001c0-.3.17999-.58.45999-.69.28-.12.6-.05.82.16l6.4 6.40001c.21.21.28.54.16.82-.11.28-.39.46-.69.46zm-5.65-5.34001v1.39001c0 1.99.46 2.45 2.45 2.45h1.39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.5996 2.75h-4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m7 5.75c-.41 0-.75-.34-.75-.75 0-2.07 1.68-3.75 3.75-3.75h2.62c.41 0 .75.34.75.75s-.34.75-.75.75h-2.62c-1.24 0-2.25 1.01-2.25 2.25 0 .41-.34.75-.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m19.1895 17.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75c1.14 0 2.06-.93 2.06-2.06v-6.19c0-.41.34-.75.75-.75s.75.34.75.75v6.19c0 1.96-1.6 3.56-3.56 3.56z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m22 8.74999h-3c-2.66 0-3.75-1.09-3.75-3.75v-3c0-.3.18-.58.46-.69.28-.12.6-.05.82.16l6 6c.21.21.28.54.16.82-.11.28-.39.46-.69.46zm-5.25-4.94v1.19c0 1.83.42 2.25 2.25 2.25h1.19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.15f0948c2dec92065b8eeb26f9f3edf3.svg";
export { ForwardRef as ReactComponent };